var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 53,
    viewBox: "0 0 400 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1707 52.0032H-177V49.7354H33.1707C36.4649 49.7435 39.728 49.0969 42.7712 47.8331C45.8144 46.5693 48.5773 44.7134 50.8999 42.3727L82.541 10.6655C85.0781 8.11314 88.0958 6.0909 91.4189 4.71607C94.7421 3.34124 98.3045 2.64118 101.9 2.6565H396.239V4.92427H101.9C98.6054 4.91516 95.342 5.56125 92.2986 6.8251C89.2553 8.08896 86.4926 9.94544 84.1706 12.287L52.5295 43.9904C49.9927 46.5435 46.9752 48.5664 43.6521 49.9419C40.3289 51.3174 36.7662 52.018 33.1707 52.0032Z",
    fill: "url(#paint0_linear_164_14446)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.235 7.54412C398.314 7.54412 400 5.85531 400 3.77206C400 1.68881 398.314 0 396.235 0C394.156 0 392.471 1.68881 392.471 3.77206C392.471 5.85531 394.156 7.54412 396.235 7.54412Z",
    fill: "url(#paint1_linear_164_14446)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_14446",
    x1: 218.351,
    y1: 27.3223,
    x2: -248.487,
    y2: 27.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_164_14446",
    x1: 8283.56,
    y1: 75.2905,
    x2: -1034.47,
    y2: 75.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL6);
export default __webpack_public_path__ + "static/media/l6.6ea094008c9748ed425d9c20020df36a.svg";
export { ForwardRef as ReactComponent };